import React from 'react'; 

export const Forbidden = () =>{
    return(
        <main>
            <div className="container component-container">
                <h2>Forbidden</h2>
                <p>Access Denied. You do not have the credentials to access this page.</p>
            </div>
        </main>
    )
}